module.exports = __webpack_public_path__ + "img/reaction.2bf999c1.png";